import { useState } from "react";
import { Box } from "@mui/material";
import { Alert } from "@mui/material";
import { Button } from "@mui/material";
import axios from "axios";
import moment from "moment";

export default function DamagesModal({ asset, refreshAssets, handleClose }) {
  const url = process.env.REACT_APP_URL;
  const [damageMessage, setDamageMessage] = useState("");
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshAssets();
      }
    }, duration);
  };

  const handleValidation = () => {
    setDisable(true);
    if (damageMessage === "" || damageMessage.length < 10) {
      handleAlert(
        "Please enter a damage description greater then 10 chars",
        "warning"
      );
    } else {
      handleDamageSubmit();
    }
  };

  const handleDamageSubmit = async () => {
    let reqBody = {
      currentUser: localStorage.getItem("userId"),
      username: localStorage.getItem("username"),
      damageMessage: damageMessage.replace(/'/g, ""),
      assetId: asset.assetId,
      assetName: asset.assetName,
    };

    await axios
      .post(`${url}/assets/asset-damage`, reqBody)
      .then((res) => {
        handleAlert("Damage has been logged", "success", true, 500);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Somthing went wrong - Please try again", "error");
      });
  };

  const handleDisableToggle = async () => {
    setDisable(true);
    let reqBody = {
      disable: !asset.disabled,
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
      assetId: asset.assetId,
    };

    await axios
      .post(`${url}/assets/disable-toggle`, reqBody)
      .then((res) => {
        handleAlert(
          `Asset has been ${asset.disabled ? "enabled" : "disabled"}`,
          "success",
          true,
          500
        );
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - Please try again", "error");
      });
  };

  const handleDeleteAsset = async () => {
    const reqBody = {
      assetId: asset.assetId,
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
    };

    await axios
      .post(`${url}/assets/delete-asset`, reqBody)
      .then((res) => {
        handleAlert("Asset has been deleted", "success", true, 500);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - Please try again", "error");
      });
  };

  return (
    <Box className="asset-damages-modal">
      <section className="asset-damages-section">
        {localStorage.getItem("access") == process.env.REACT_APP_ADMIN_ID &&
        !asset.disabled ? (
          <Button
            variant="contained"
            color={asset.disabled ? "success" : "error"}
            className="disable-asset-btn"
            disabled={disable}
            onClick={handleDisableToggle}
          >
            {asset.disabled ? "Enable" : "Disable"}
          </Button>
        ) : null}
        <h2>Damages Log</h2>
        {asset?.damages && asset.damages.length > 0 ? (
          <section className="damages-table-container">
            <table className="damages-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Note</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {asset.damages.map((d, i) => {
                  return (
                    <tr key={i}>
                      <td>{d.userName}</td>
                      <td>{d.note}</td>
                      <td>{moment(d.date).format("DD/MM/YY")}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
        ) : null}
        {!asset.disabled ? (
          <>
            <p>
              To log a damage for the asset: <b>{asset.assetName}</b>, please
              enter a description below and submit.
            </p>
            <textarea
              className="damage-description"
              value={damageMessage}
              onChange={(e) => {
                setDamageMessage(e.target.value);
              }}
              placeholder="Enter damage description"
            ></textarea>
          </>
        ) : (
          <section className="damage-disabled">
            <Button
              variant="contained"
              color="warning"
              onClick={handleDeleteAsset}
            >
              Archive
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleDisableToggle}
            >
              Enable
            </Button>
          </section>
        )}
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            color="error"
            variant="contained"
            onClick={() => handleClose(false)}
            disabled={disable}
          >
            close
          </Button>
          <Button
            variant="contained"
            color="success"
            disabled={disable || asset.disabled}
            onClick={handleValidation}
          >
            Submit
          </Button>
        </section>
      </section>
    </Box>
  );
}
